import { TextField } from "@mui/material";
import React from "react";

interface WeightPerPieceInputProps {
	value: number | string;
	error: boolean;
	helperText: string | undefined;
	className?: string;
}

export const WeightPerPieceInput: React.FC<WeightPerPieceInputProps> = ({
	value,
	error,
	helperText,
	className,
}) => {
	return (
		<TextField
			error={error}
			helperText={helperText}
			value={value}
			InputProps={{
				readOnly: true,
			}}
			fullWidth
			variant="outlined"
			size="small"
			className={className}
		/>
	);
};
